/* global swal */
import './style.less';

export default function(
  $stateParams,
  $state,
  $uibModalInstance,
  $log,
  $timeout,
  $filter,
  $location,
  $window,
  ApiClass,
  ProfileClass
) {
  'ngInject';

  function close() {
    $uibModalInstance.dismiss('cancel');
  }

  try {
    const { profile } = ProfileClass.profileComplete;
    const profile_uid = $stateParams.employeeID || $stateParams.id || profile.profile_uid;

    const vm = this;
    vm.resultsQueried = false;
    vm.formData = ProfileClass.userProfile;

    ProfileClass.profileGet(vm.formData.profile_uid)
      .then(({ email }) => {
        vm.formData.email = email;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });

    vm.update = function() {
      const updateInfo = {
        profile_uid: vm.formData.profile_uid,
        first: vm.formData.first,
        last: vm.formData.last,
        firstLogin: false
        // TODO: Finish getting started
        // gettingStarted: true
      };
      vm.profileUpdate = true;
      ApiClass.usersIdPatch({ id: profile_uid, manage: false }, updateInfo)
        .then(() => {
          vm.profileUpdate = false;
          close();
          $state.go('app.users.dashboard', $stateParams);
          // TODO: Finish getting started
          // $state.go('app.users.gettingStarted', $stateParams);
        })
        .catch(error => {
          swal('Error', 'Please review and submit again', 'warning');
          vm.profileUpdate = false;
          $log.error(error);
          throw error;
        });
    };
  } catch (error) {
    $log.error(error);
    throw error;
  }
}



// WEBPACK FOOTER //
// ./src/app/modals/onboardProfile/index.js